var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40959 14H2.66231C2.29642 14 2 13.7034 2 13.3377V2.6623C2 2.29646 2.29646 2 2.66231 2H13.3377C13.7035 2 14 2.29646 14 2.6623V13.3377C14 13.7034 13.7034 14 13.3377 14H10.2798V9.35294H11.8396L12.0732 7.5419H10.2798V6.38566C10.2798 5.86132 10.4254 5.504 11.1773 5.504L12.1363 5.50358V3.88377C11.9705 3.8617 11.4012 3.81239 10.7389 3.81239C9.35621 3.81239 8.40959 4.65638 8.40959 6.2063V7.5419H6.84578V9.35294H8.40959V14Z",
    fill: "#949BA8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.781fa14f8054ad28b8307aecfc006130.svg";
export { ForwardRef as ReactComponent };